var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.768 2.16495C14.6907 1.15979 13.9175 0.309277 12.835 0.23196C11.2886 0.0773174 9.12368 0 7.5 0C5.87629 0 3.71134 0.0773174 2.16495 0.23196C1.62371 0.23196 1.15979 0.46392 0.850515 0.850515C0.541238 1.23711 0.309277 1.62371 0.23196 2.16495C0.0773174 3.71134 0 5.87629 0 7.5C0 9.12368 0.154642 11.2886 0.23196 12.835C0.309277 13.8402 1.08247 14.6907 2.16495 14.768C3.71134 14.9227 5.87629 15 7.5 15C9.12368 15 11.2886 14.8454 12.835 14.768C13.8402 14.6907 14.6907 13.9175 14.768 12.835C14.9227 11.2886 15 9.12368 15 7.5C15 5.87629 14.9227 3.71134 14.768 2.16495ZM10.2062 6.3402L7.11337 9.43297C6.95872 9.5103 6.88147 9.58762 6.72682 9.58762C6.57218 9.58762 6.41752 9.5103 6.3402 9.43297L4.79381 7.88663C4.56185 7.65465 4.56185 7.26802 4.79381 7.03605C5.02577 6.80415 5.41237 6.80415 5.64433 7.03605L6.80415 8.19585L9.5103 5.48969C9.74228 5.25773 10.1289 5.25773 10.3608 5.48969C10.4381 5.79897 10.4381 6.10822 10.2062 6.3402Z",
    fill: "#096A86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.57c0de54fbe89925696548c9895aed74.svg";
export { ForwardRef as ReactComponent };